import React, { useRef, useState } from 'react'
import { FiSearch } from 'react-icons/fi'

import { debounce } from 'lodash'

import Input from '~/components/Form/Input'
import { history } from '~/helpers'
import useQueryParams from '~/hooks/useQuery'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

// import { Container } from './styles';

const AudienceEnrichedFilters: React.FC = () => {
  const [innerLoading, setInnerLoading] = useState(false)

  const { t } = useAPPTranslation()

  const params = useQueryParams()
  const name = params.get('name')
  const key = params.get('key')

  // Filter
  const executeDebounceFunc = (func: () => void) => func()

  const handleDebounce = useRef(debounce(executeDebounceFunc, 1000)).current

  const handleFilter = (data: OnChangeInputData) => {
    const { name, value } = data

    if (!value) {
      const newParams = new URLSearchParams(params.toString())
      newParams.delete(name)
      history.push({ search: newParams.toString() })
      setInnerLoading(false)

      return
    }

    params.set(name, String(value))
    params.set('page', '1')
    history.push({ search: params.toString() })

    setInnerLoading(false)
  }

  const handleChange = (data: OnChangeInputData) => {
    setInnerLoading(true)
    handleDebounce(() => handleFilter(data))
  }

  return (
    <form className="d-flex gap-2 mb-2">
      <Input
        name="name"
        onChange={handleChange}
        defaultValue={name}
        icon={FiSearch}
        placeholder={t('rm:filterByName')}
        type="search"
        loading={innerLoading}
      />

      <Input
        name="key"
        onChange={handleChange}
        defaultValue={key}
        icon={FiSearch}
        placeholder={t('rm:filterByKey')}
        type="search"
        loading={innerLoading}
      />
    </form>
  )
}

export default AudienceEnrichedFilters
